module.exports = __webpack_public_path__ + "static/media/user.9d1403c3.png";